module.exports = __webpack_public_path__ + "img/sht.002e9dc2.jpg";